import {useTranslation} from 'hooks/translations/useCustomTranslation';
import dynamic from 'next/dynamic';
import React, {FC, useCallback, useContext, useState} from 'react';

import {Group} from 'lib/api/backend.schemas';
import {TypoComponentsFahrzeugliste} from 'lib/api/strapi';

import {bestPriceGroupCardFlip} from 'utils/tagManagerHelpers/gtmEventsParsing';

import {Box, Grid} from 'components/basic-components';
import ResponseMessage from 'components/basic-components/ResponseMessage';
import {withErrorBoundary} from 'components/error/ErrorBoundary';
import {ConsentContext} from 'components/section-components/ConsentManager';
import BPRModal from 'components/section-components/bpr/BPRModal/BPRModal';
import ResultCardMobile from 'components/section-components/reservation/step1/ResultCard/ResultCardMobile';

import {useGetApiV1GroupsByType} from '../../../lib/api/backend';
import styles from './Fahrzeugliste.module.scss';

const RotatingLines = dynamic(() => import('components/basic-components/RotatingLines'));

const Fahrzeugliste: FC<TypoComponentsFahrzeugliste> = ({type, ...props}) => {
  const {t} = useTranslation('strapiComponents');
  const [selectedGroup, setSelectedGroup] = useState<Group>({} as Group);
  const [selectedVehicle, setSelectedVehicle] = useState<string>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const {pushDataLayer} = useContext(ConsentContext);

  const clickResultCard = useCallback(() => {
    pushDataLayer(bestPriceGroupCardFlip(selectedGroup, 'bpr_cts'));
  }, [selectedGroup]);

  const {
    isLoading,
    error,
    isSuccess,
    data = [],
  } = useGetApiV1GroupsByType(type, {
    withImages: true,
    onlyBookable: props.onlyBookable,
    category: props.category,
  });
  if (!isLoading && isSuccess && Array.isArray(data) && !data?.length) {
    return null;
  }

  return (
    <Box className={styles.wrapper}>
      <Grid container columnSpacing={'2%'} rowSpacing={'20px'}>
        {isLoading ? (
          <Box component="span" className={styles.loadingWrapper}>
            <RotatingLines width="120" strokeWidth="3" strokeColor="#feed01" />
          </Box>
        ) : error ? (
          <ResponseMessage variant="error">{t('errorMessage')}</ResponseMessage>
        ) : (
          <>
            <BPRModal
              modalOpen={modalOpen}
              presetGroup={selectedGroup?.id}
              minDate={selectedGroup?.bookableFrom}
              maxDate={selectedGroup?.bookableTo}
              presetCategory={selectedGroup?.category}
              preferredVehicle={selectedVehicle ? selectedVehicle : null}
              presetType={selectedGroup?.type}
              presetVip={selectedGroup?.vip}
              setModalOpen={setModalOpen}
              hideOneWay={!selectedGroup?.oneWay}
              isTeaser={true}
            />
            {Array.isArray(data) &&
              data?.map((group: Group, key: Number) => {
                return (
                  <Grid xxs={12} sm={6} md={4} xxl={4} key={`${group.type}-${key}`}>
                    <ResultCardMobile
                      group={group}
                      clickHandler={(group, selectedVehicle) => {
                        setSelectedGroup(group);
                        setSelectedVehicle(selectedVehicle);
                        clickResultCard();
                        setModalOpen(true);
                      }}
                    />
                  </Grid>
                );
              })}
          </>
        )}
      </Grid>
    </Box>
  );
};

export default withErrorBoundary(Fahrzeugliste, 'Fahrzeugliste');
